export default __webpack_public_path__ + "static/media/duration.ab181368.svg";